<template>
	<VSWell v-if="condition" variant="error" size="sm" class="banner">
		<slot></slot>
	</VSWell>
</template>

<script>
import { VSWell } from '@component/UI';

export default {
	components: { VSWell },
	props: {
		condition: {
			type: Boolean,
			required: true,
		},
	},
	watch: {
		condition() {
			if (this.condition) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.banner {
	margin-bottom: var(--size-lg);

	&__content {
		display: flex;
		flex-direction: column;
		gap: var(--size-md);

		> p {
			margin: 0;
		}
	}

	&__list {
		margin: 0;
		padding: 0;
		list-style: none;
	}
}
</style>
